import React from 'react';
import { Modal, ModalBody, Button } from 'reactstrap';
import { IconGift, IconExternalLink } from '@tabler/icons-react';
import { appendReferralParams } from '../../../shared/utility';
import { renderMarkdownToReact } from '../../../components/UI/MarkdownText/MarkdownText';
import styles from './WinModal.module.scss';

const WinModal = ({
    isOpen,
    winCta,
    hasTicket,
    goldenFact,
    matchedPairsCount,
    totalPairsCount,
    attempts,
    onRedeem,
    onRestart,
    backdropClassName,
    cardColorType,
    cardCustomColor,
}) => {
    if (!isOpen) return null;

    const rawUrl = goldenFact?.linkUrl || winCta?.linkUrl;
    const hasLink = rawUrl && rawUrl !== '#';
    const destinationUrl = hasLink ? appendReferralParams(rawUrl) : null;
    const isExternal =
        destinationUrl && (destinationUrl.startsWith('http://') || destinationUrl.startsWith('https://'));

    const resolvedThemeColor =
        cardColorType === 'secondary'
            ? 'var(--bs-secondary, #6c757d)'
            : cardColorType === 'custom' && cardCustomColor
              ? cardCustomColor
              : undefined;

    const modalStyle =
        !hasTicket && resolvedThemeColor
            ? {
                  backgroundColor: resolvedThemeColor,
              }
            : {};

    const isDarkBg =
        winCta?.buttonColorType === 'primary' ||
        winCta?.buttonColorType === 'secondary' ||
        (winCta?.buttonColorType === 'custom' && winCta?.buttonColor !== '#f5a623');

    const buttonStyle = winCta?.buttonColor
        ? {
              backgroundColor: winCta.buttonColor,
              color: isDarkBg ? '#ffffff' : 'var(--bs-dark, #212529)',
          }
        : {};

    return (
        <Modal
            isOpen={isOpen}
            toggle={onRestart}
            centered
            className="mx-auto"
            contentClassName="border-0 shadow-lg"
            backdropClassName={backdropClassName}
            style={{ maxWidth: '360px' }}
        >
            <ModalBody className={`${styles.modalContent} ${hasTicket ? styles.specialWin : ''} text-center p-4 d-flex flex-column align-items-center gap-3 rounded-3`} style={modalStyle}>
                <div className="d-flex align-items-center justify-content-center my-1">
                    <IconGift size={36} stroke="var(--bs-dark, #212529)" strokeWidth={2.5} />
                </div>

                <div className="w-100">
                    <h2 className={`h5 mb-2 fw-bold ${hasTicket ? 'text-dark' : 'text-white'}`}>{winCta?.headline || 'Herzlichen Glückwunsch!'}</h2>
                    <p className={`small mb-0 ${hasTicket ? 'text-dark' : 'text-white'}`}>
                        {renderMarkdownToReact(
                            hasTicket
                                ? goldenFact?.copy ||
                                  'Du hast alle Paare gefunden und dir eine Chance auf einen Wunschgutschein gesichert!'
                                : winCta?.copy || 'Du hast alle Paare erfolgreich gefunden. Gut gespielt!'
                        )}
                    </p>
                </div>

                {/* Stats Summary inside completion modal */}
                <div
                    className="w-100 rounded-3 p-3 d-flex flex-column gap-1 text-start"
                    style={{
                        backgroundColor: hasTicket ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.15)',
                        fontSize: '14px',
                        color: hasTicket ? 'var(--bs-dark, #212529)' : '#ffffff',
                    }}
                >
                    <div className="d-flex justify-content-between">
                        <span>Gefundene Paare:</span>
                        <span className="fw-bold">
                            {matchedPairsCount}/{totalPairsCount}
                        </span>
                    </div>
                    <div className="d-flex justify-content-between">
                        <span>Versuche:</span>
                        <span className="fw-bold">{String(attempts).padStart(3, '0')}</span>
                    </div>
                </div>

                {hasTicket ? (
                    hasLink ? (
                        <Button
                            href={destinationUrl}
                            tag="a"
                            target="_blank"
                            rel="noopener"
                            color="white"
                            className="w-100 fw-bold border-0 text-dark py-2"
                            style={{ borderRadius: '8px', fontSize: '16px' }}
                        >
                            <span className="d-flex align-items-center justify-content-center gap-1">
                                {winCta?.buttonText || 'Sofort einlösen'}
                                {isExternal && <IconExternalLink size={16} />}
                            </span>
                        </Button>
                    ) : (
                        <Button
                            onClick={() => onRedeem()}
                            color="white"
                            className="w-100 fw-bold border-0 text-dark py-2"
                            style={{ borderRadius: '8px', fontSize: '16px' }}
                        >
                            <span className="d-flex align-items-center justify-content-center gap-1">
                                {winCta?.buttonText || 'Sofort einlösen'}
                            </span>
                        </Button>
                    )
                ) : hasLink && winCta?.buttonText ? (
                    <Button
                        href={destinationUrl}
                        tag="a"
                        target="_blank"
                        rel="noopener"
                        color="yellow"
                        className="w-100 fw-bold border-0 text-dark py-2"
                        style={{ borderRadius: '8px', fontSize: '16px', ...buttonStyle }}
                    >
                        <span className="d-flex align-items-center justify-content-center gap-1">
                            {winCta.buttonText}
                            {isExternal && <IconExternalLink size={16} />}
                        </span>
                    </Button>
                ) : (
                    <Button
                        onClick={onRestart}
                        color="yellow"
                        className="w-100 fw-bold border-0 text-dark py-2"
                        style={{ borderRadius: '8px', fontSize: '16px', ...buttonStyle }}
                    >
                        <span className="d-flex align-items-center justify-content-center gap-1">
                            Noch einmal spielen
                        </span>
                    </Button>
                )}
            </ModalBody>
        </Modal>
    );
};

export default WinModal;
